const apiUrl = process.env.REACT_APP_API_URL;

export const fetchUserPaymentMethods = async () => {
  const token = localStorage.getItem('access_token');

  const response = await fetch(`${apiUrl}/GET/user_payment_method_id_user`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Error fetching user payment methods');
  }

  return response.json();
};

export const createUserPaymentMethod = async paymentMethodData => {
  const response = await fetch(`${apiUrl}/POST/user_payment_method`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(paymentMethodData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Error creating user payment method');
  }

  return response.json();
};
